var ssd = "https://shopfront-cdn.tekoapis.com/static/f9387823f4497274.svg";

export { ssd as default };
